import { useQuery } from '@tanstack/react-query'
import { monetizationService } from '../services/monetizationService'

export function useMonetizationSummary(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ['monetization-summary', fromDate, toDate],
    queryFn: () => monetizationService.getMonetizationSummary(fromDate, toDate),
    staleTime: 2 * 60 * 1000,
  })
}
